type PopGuard = (event: PopStateEvent) => void;
const guards = new Map<symbol, PopGuard>();

// Import at app bootstrap, before BrowserRouter registers its history listener.
// A listener mounted inside a lazy record page can run after Router has already
// queued the POP and unmounted its draft, even when that listener restores the URL.
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', event => {
    for (const guard of [...guards.values()].reverse()) {
      guard(event);
      if (event.cancelBubble) return;
    }
  }, true);
}

export function registerRecordEditPopGuard(guard: PopGuard): () => void {
  const id = Symbol('record-edit');
  guards.set(id, guard);
  return () => { guards.delete(id); };
}
